import request from '@ps/utils/request'
export const sleep = (delay: number): Promise<undefined> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(undefined)
    }, delay)
  })
}

interface FileInfo {
  is_dir: boolean
  name: string
  items?: Array<FileInfo>
  ext?: string
  size?: string
}

export const findFileInfo = (
  source: FileInfo,
  src: string,
): FileInfo | null => {
  if (source.name === src) {
    return source
  }
  if (Array.isArray(source.items)) {
    for (const item of source.items) {
      const info = findFileInfo(item, src)
      if (info) return info
    }
  }
  return null
}

export const getAudioInfoByUrl = async (url: string) => {
  if (window.AudioContext) {
    const cookedUrl = (
      /^http(s)?:\/\//.test(url) ? url : `${location.origin}${url}`
    ).replace(/^http(s)?:/, location.protocol)
    const audioContext = new window.AudioContext()
    const data = (await request({
      url: cookedUrl,
      method: 'get',
      responseType: 'arraybuffer',
    })) as ArrayBuffer
    const audioInfo = await audioContext.decodeAudioData(data)
    return audioInfo
  }
}

export const banENumberInput = (evt: KeyboardEvent): boolean => {
  const key = evt.key
  // 数字控件不允许输入'e'和'E'
  if (key === 'e' || key === 'E') {
    evt.preventDefault()
    // evt.returnValue = false
    return false
  }
  return true
}

export const flatObject = (obj: any) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (typeof obj[key] !== 'object') {
      // @ts-ignore
      acc[key] = obj[key]
      return acc
    }
    return { ...acc, ...obj[key] }
  }, {})
}
